export default __webpack_public_path__ + "static/media/MTcarpaFull_LateralDer.040756ab.webp";